import React from 'react';
import ReactDOM from 'react-dom/client';
// Display face for titles (tailwind font-display), served from our own bundle.
import '@fontsource/barlow-condensed/700.css';
import '@fontsource/barlow-condensed/800.css';
import './index.css';
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';
import { initializeAnalytics, initializeClarity, installErrorTracking, trackWebVital } from './analytics';
import { applyConsentDefaults, syncClarityConsent } from './consent';

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-C0Z1VM8JKR';
// Consent defaults must reach the dataLayer before GA's config (see consent.js).
applyConsentDefaults();
initializeAnalytics(measurementId);
installErrorTracking();
initializeClarity(process.env.REACT_APP_CLARITY_PROJECT_ID || 'yvur21evoc');
syncClarityConsent();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);

// Real-visitor load speed (LCP, CLS, FID, FCP, TTFB) goes to GA.
reportWebVitals(trackWebVital);
